import * as React from 'react';
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Table, TableCell, TableContainer, TableRow, TableHead, TableBody, TextField, FormControl } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import PageInfo from 'components/PageInfo';
import queryString from 'query-string';
import { useState } from 'react';
import { useEffect } from 'react';
import { getGatewaysByQuery, getGatewaysByQueryString } from 'components/axios/iotAxios';
import dayjs from 'dayjs';
import { useEnumApi } from 'contexts/EnumApiContext';
import CustomEnumSelect from 'components/select/CustomEnumSelect';
import { BootstrapInput } from 'data/data';

const GatewaySetting = () => {
    const { getEnumValueByEnumNameAndCode } = useEnumApi();
    const { t } = useTranslation();

    const navigate = useNavigate();
    const [searchField, setSearchField] = useState('sn');
    const [searchKeyword, setSearchKeyword] = useState('');
    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(process.env.REACT_APP_DEFAULT_PAGE_SIZE);
    const [gateways, setGateways] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isParam, setIsParam] = useState(false);
    // const [searchFields] = useState([{code:"sn", title:"S/N"}, {code:"wifiMacAdr", title:"MAC"}, {code:"no", title:t('message.common.subtitle.equipment.number')}]);
    const [searchFields] = useState([{code:"sn", title:"S/N"}, {code:"wifiMacAdr", title:"MAC"}]);

    const [sortModel, setSortModel] = useState(null);
    const [searchParam, setSearchParam] = useState({});
    const [searchParamString, setSearchParamString] = useState('');

    const connectProblemDay = dayjs(new Date()).subtract(7, "d").format("YYYY-MM-DD");
    const qs = queryString.parse(window.location.search);
    
    const columns = [
        { field: 'no', headerName: 'No.', sortable: false, width: 80
          , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.no}</Link>)
        },
        { field: 'madeBy', headerName: t('message.common.subtitle.manufacturing.company'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.madeBy}</Link>) 
        },
        { field: 'sn', headerName: 'S/N', sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.sn}</Link>)
        },
        { field: 'wifiMacAdr', headerName: 'MAC', sortable:true, width: 100
          , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.wifiMacAdr}</Link>)
        },
        // { field: 'apGwIp', headerName: 'IP', sortable:true, width: 120
        //   , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.apGwIp}</Link>)
        // },
        // { field: 'station.workingPart.subwayLine', headerName: t('message.common.subtitle.subwayline'), sortable:true,  width: 150
        //   , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.station?.workingPart?.subwayLine 
        //     && getEnumValueByEnumNameAndCode("SubwayLine", params.row?.station?.workingPart?.subwayLine)?.[0].title}</Link>)
        // },
        // { field: 'station.workingPart.name', headerName: t('message.common.subtitle.workingPart'), sortable:true, minWidth: 200
        //   , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.station?.workingPart?.name}</Link>)
        // },
        // { field: 'station.name', headerName: t('message.common.subtitle.station'), sortable:true, width: 150
        //   , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.station?.name}</Link>)
        // },
        // { field: 'equipments.equipment.name', headerName: t('message.common.subtitle.equipment.name')+'('+t('message.common.subtitle.equipment.number')+')', sortable:true, width: 120
        //     , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.equipments?.equipment?.name}{params.row?.equipments?.equipment?.equipmentNo && '('+params.row?.equipments?.equipment?.equipmentNo+')'}</Link>)
        // },
        { field: 'latestCommedAt', headerName: t('message.common.subtitle.communication'), sortable:true, width: 200
          , renderCell:(params)=>(<div 
            className={params.row?.latestCommedAt !== null ? (params.row?.latestCommedAt < connectProblemDay ? 'red' : 'black') : 'red'}
            ><Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.latestCommedAt}</Link></div>)
        },
        { field: 'instlYmd', headerName: t('message.common.subtitle.installation.date'), sortable:true, width: 150
          , renderCell:(params)=>(<Link to={'/setting/iot/gateway/'+params.row?.id+searchParamString}>{params.row?.instlYmd}</Link>)
        },
    ];

    const handlePaging = (value) => {
      value = isNaN(value) ? 1 : value;
      setCurrentPage(value-1);
      setIsLoading(false);

      let searchParamCopy = {...searchParam};
      searchParamCopy.page = (value-1);
      setSearchParam(searchParamCopy);
    }
    
    useEffect(()=>{
        const searchOrders = searchParam.searchOrder;
        const searchParamCopy = {...searchParam};
        delete searchParamCopy.searchOrder;
        let searchString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
        if (searchOrders && searchOrders.length > 0) {
          let sortString = '';
          searchOrders.forEach(order=>sortString+="&sort="+order.sort)
          searchString += sortString;
        }
        setSearchParamString("?"+searchString)
    }, [searchParam])
    
    useEffect(()=>{
        const searchParamCopy = {...searchParam};
        let searchOrders = [];
        if (sortModel && sortModel.length > 0) {
          searchOrders.push({sort : sortModel[0].field+","+sortModel[0].sort});
        }
        searchParamCopy.searchOrder = searchOrders;
        setSearchParam(searchParamCopy)
    },[sortModel])

    useEffect(()=> {
        if (qs) {
            if (qs.page && qs.page !== (currentPage)) {setCurrentPage(qs.page);}
            if (qs.size) setPageSize(qs.size);
            if (qs.searchField) setSearchField(qs.searchField);
            if (qs.searchKeyword) setSearchKeyword(qs.searchKeyword);

            let searchParamCopy = {...searchParam};
            if (qs.page && qs.page !== (currentPage)) {searchParamCopy.page = qs.page};
            if (qs.size) {searchParamCopy.size = qs.size} ;
            if (qs.searchField) {searchParamCopy.searchField = qs.searchField};
            if (qs.searchKeyword) {searchParamCopy.searchKeyword = qs.searchKeyword};
            if (qs.sort && qs.sort.length > 0) {
                let orders = [];
                let sortModel = [];
                if (!Array.isArray(qs.sort)) {
                  orders.push({sort:qs.sort});
                  sortModel.push({"field": qs.sort.split(',')[0],"sort": qs.sort.split(',')[1]})
                } else {
                  (qs.sort).forEach(order=>orders.push({sort:order}));
                  qs.map(order=>sortModel.push({"field": order.sort.split(',')[0],"sort": order.sort.split(',')[1]}))
                }
                setSortModel(sortModel)
                searchParamCopy.searchOrder = orders;
            } else {
                delete searchParamCopy.searchOrder
            };
            setSearchParam(searchParamCopy);
        }
        setIsParam(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [qs.page, qs.size, qs.searchField, qs.searchKeyword]);
    
    useEffect(()=> {
        if ((!isLoading || sortModel != null)  && !isNaN(currentPage) && isParam) {
            gatewaysList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading, isParam, sortModel]);

    const gatewaysList = async(curPage=currentPage) => {
        isNaN(curPage) && setCurrentPage(0);
        isNaN(pageSize) && setPageSize(process.env.REACT_APP_DEFAULT_PAGE_SIZE);

        let param = {
            page : curPage,
            size : pageSize
        };
        let keyword = searchKeyword;
        if (searchKeyword) {
            if (searchField && (searchField === 'wifiMacAdr')) {
                keyword = 'contains('+searchKeyword+')';
            }

            if (searchField === 'wifiMacAdr') {
                param.wifiMacAdr = keyword;
            } else if (searchField === 'sn') {
                param.sn = keyword;
            // } else if (searchField === 'no') {
            //     param['equipments.equipment.equipmentNo'] = 'contains('+keyword+')';
            }
        }
        let addQueryString = "";
        if (sortModel && sortModel.length > 0)
          addQueryString += "&sort="+sortModel[0].field+","+sortModel[0].sort;
        else
          addQueryString += "";
        let queryString = Object.entries(param).map(([key, value]) => (key + '=' + value)).filter(v => v).join('&');
        queryString += addQueryString;
        await getGatewaysByQueryString("?"+queryString).then((data)=>{
            if (data != null) {
                setPageInfo(data.page);
                if(data._embedded && data._embedded.gatewayDTOes) {
                    let list = data._embedded.gatewayDTOes;
                    list && list.map(function(gateway, i) {
                        gateway.idx = (i+1);
                        gateway.no = data.page.totalElements-((currentPage)*data.page.size)-i;
                    })

                    setGateways(list);
                } else {
                    setCurrentPage(0);
                    setGateways([]);
                }
            } else {
                pageInfo = {
                    size : pageInfo.size,
                    totalElements : 0,
                    totalPages : 0,
                    number : 0
                }
                setPageInfo(pageInfo);
                setGateways([]);
            }
        });
        setIsLoading(true);
    }

    const handleSelect = (event, value) => {
        event.preventDefault();
        setSearchField(value.props.value);
    };

    const handleInput = (event) => {
        event.preventDefault();
        setSearchKeyword(event.target.value.trim());
    };

    const handleOnKeyPress = e => {
    if (e.key === 'Enter') {
        handleSearch(e); // Enter 입력이 되면 클릭 이벤트 실행
    }
    };

    const handleSearch = (event) => {
        event.preventDefault();
        setCurrentPage(0);
        pageInfo.number = 0;
        setPageInfo(pageInfo);
        gatewaysList(0);

        let searchParamCopy = {...searchParam};
        searchParamCopy.page = 0;
        if (pageSize) {searchParamCopy.size = pageSize};
        if (searchField) {searchParamCopy.searchField = searchField};
        if (searchKeyword) {searchParamCopy.searchKeyword = searchKeyword};
        setSearchParam(searchParamCopy)
        const paramString = Object.entries(searchParamCopy).map(([key, value]) => ( key+'='+value)).filter(v=>v).join('&');
        console.log(paramString)
        navigate("?"+paramString)
    };
    
    return (
    <div className='cal' style={{padding:"15px 0"}}>
        <Box sx={{ minWidth: 120 }}>
        {isLoading && 
        <>
            <FormControl sx={{ m: 1, minWidth: 120 }}>
                <CustomEnumSelect
                    key={searchField}
                    label={t('message.common.btn.search')}
                    labelName={t('message.common.btn.search')}
                    name={'searchField'}
                    defaultValue={searchField}
                    onChange={(e)=>{
                        setSearchField(e.target.value);
                    }}
                    isLabelView={false}
                    list={searchFields}
                />
            </FormControl>

            <FormControl sx={{ m: 1 }} variant="standard">
                <BootstrapInput id="demo-customized-textbox" value={searchKeyword} onChange={handleInput} onKeyPress={handleOnKeyPress} />
            </FormControl>

            <Button variant="contained" style={{marginTop:"7px",padding:"7px 15px"}} onClick={handleSearch}>
              <span className="icon_png"><img src={`${process.env.PUBLIC_URL}/img/icon/search.png`} alt='' /></span>{t('message.common.btn.search')}
            </Button>
        </>
        }
        </Box>

        <Box id="tableDiv" style={{borderTop:"2px solid #a2a2a2"}}>
          <DataGridPro
            rows={gateways && gateways !== undefined ? gateways : []}
            columns={columns}
            disableColumnFilter
            sortModel={sortModel || []}
            onSortModelChange={setSortModel}
            sx={{
              "& .MuiDataGrid-footerContainer, & .MuiDataGrid-toolbarContainer": {
                display: "none",
              },
              "& .MuiDataGrid-cell.statusReport" : {overflow:"unset !important"}
            }}
          />
        </Box>

        <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>
    </div>
    );
}

export default GatewaySetting;